module.exports = __webpack_public_path__ + "static/media/awards_03.966ee87e.png";